import { getRecentHistory } from '@/pages/workshop/service';
import { ref } from 'vue';
import _ from 'lodash';

/**
 * 最近历史访问模块
 * @param immediate 立刻请求
 * @returns {(Ref<UnwrapRef<*[]>>|setHistory)[]}
 */
const history = ref([]); // 放外面可缓存一下
const isLoading = ref(false);
// 节流处理下。
const setHistory = _.throttle(() => {
  isLoading.value = true;
  getRecentHistory()
    .then(
      (res) =>
        // 增加tag是否选中状态
        (history.value = res.map((e) => {
          e.isChoose = false;
          return e;
        })),
    )
    .finally((_) => {
      isLoading.value = false;
    });
}, 1000);
export function useRecentHistory(immediate) {
  if (immediate) {
    setHistory();
  }
  return [history, setHistory, isLoading];
}
